var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListItem',{attrs:{"title":_vm.$globals.ENV_MOBILE_DEVICE ? _vm.$t('settings.reset.title') : _vm.$t('settings.reset.title-desktop'),"subtitle":_vm.$globals.ENV_MOBILE_DEVICE
      ? _vm.$t('settings.reset.subtitle')
      : _vm.$t('settings.reset.subtitle-desktop'),"data-cy":"reset"},on:{"click":_vm.resetConfirm}},[_c('ListItemCircle',{attrs:{"slot":"icon"},slot:"icon"},[_c('SignOut')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }